const $ = jQuery.noConflict();

class HeaderMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-has-children');
		this.menuItemsLinks = this.menuItems.find('> a');
		this.search = $('.btn-search');
		this.hamburger = $('.btn-hamburger');
	}
	bindHeaderEvents() {
		this.search.on('click', this.toggleSearchBar);
		this.menuItemsLinks.on('click', this.toggleChildMenu);
		const body = $('body');
    const pageHeader = $('header.main-header');
    const classesToAdd = 'header-hero-homepage bg-transparent';
		if (
			body.hasClass('tax-people_category') ||
			body.hasClass('tax-job_type') ||
			body.hasClass('taxonomy-term-page') ||
			body.hasClass('tax-tour_type') ||
			body.hasClass('tax-tour_age') ||
			body.hasClass('tax-tour_focus') ||
			body.hasClass('tax-tour_adventure_length') ||
			body.hasClass('tax-tour_departure_month')
		) {
			pageHeader.addClass(classesToAdd);
		}
		if ($(window).width() > 1199) {
			const insideMenuItem = document.querySelector('.main-header__nav');
			const searchBtn = document.querySelector('.btn-search');
			const searchForm = document.querySelector('.search-wrapper');
			document.body.addEventListener("click", function(evt) {
				if (!insideMenuItem.contains(evt.target) && !searchBtn.contains(evt.target) && !searchForm.contains(evt.target)) {
					HeaderMenu.closeMenu();
          HeaderMenu.searchTrigger();
					HeaderMenu.hideMegaMenu();
          HeaderMenu.hideSearchBar();
          $('.btn-search').removeClass('open');
          $('body').removeClass('search-active');
					HeaderMenu.animateMenuBackground(false);
				}
			});
		}
	}
	submitSearchForm() {
		$('body').on('click', '#submit_form', function(){
			$(".search-form").submit();
		});
	}
	bindMobileEvents() {
    const mobileMenu = $('.main-header__nav');
    const mobileMenuItems = mobileMenu.find('> .menu > .menu-item-has-children');
    mobileMenuItems.each(function() {
      const menuLabel = $(this).find('> a').text();
      const subMenu = $(this).find('> .sub-menu ');
      if (subMenu.length > 0) {
        const headLi = '<li><div class="menu-mobile-action">'+
					'<div class="menu-mobile-action_top"><a class="backBtn" href="#"><i class="icon icon-chev-left"></i></a><span>All</span>'+
					'<a class="closeMenu" href="#"><i class="icon icon-close"></i></a></div>'+
					'<div class="menu-mobile-action_heading">'+menuLabel+'</div>'+
					'</div></li>';
          subMenu.prepend(headLi);
        }
      });
      $("#menu-mobile-main-nav .mega-menu-wrapper > .container > .row").addClass('row-block');
      this.bindBackEvents();
    }
	toggleChildMenu(e) {
		e.preventDefault();
		const subMenuWrapper = $(this).next('.sub-menu');
      if (!subMenuWrapper.hasClass('active')) {
				HeaderMenu.animateMenuBackground(true);
				HeaderMenu.hideSearchBar();
				$('.btn-search').removeClass('open');
				HeaderMenu.hideMegaMenu();
				HeaderMenu.showMegaMenu($(this).closest('.menu-item-has-children'));
      } else {
        HeaderMenu.hideMegaMenu();
        HeaderMenu.animateMenuBackground(false);
      }
	}
	toggleSearchBar(e) {
		e.preventDefault();
		if (!$('.search-wrapper').hasClass('active')) {
      if ($(window).width() < 1200 && $('.btn-hamburger').hasClass('open') ) {
				$('.btn-hamburger').trigger('click');
        $('.btn-hamburger').removeClass('open');
			}
      HeaderMenu.animateMenuBackground(true);
			HeaderMenu.hideMegaMenu();
			HeaderMenu.activeSearchBar();
			HeaderMenu.closeMenu();
			HeaderMenu.searchTrigger();
			$('body').addClass('search-active');			
			$('.main-header').addClass('menu-active');
			$(this).addClass('open');
		} else {
			HeaderMenu.hideSearchBar();
			$(this).removeClass('open');
			$('body').removeClass('search-active');
      HeaderMenu.animateMenuBackground(false);
			$('.main-header').removeClass('menu-active');
		}
	}
	  
	sticky() {
		$(window).scroll(function () {
		  const scroll = $(window).scrollTop();
		  if (scroll >= 20) {
				$('.main-header').addClass('sticky');
		  } else {
				$('.main-header').removeClass('sticky');
		  }
		});
	}
	  
  static searchTrigger() {
    $('.main-header__nav ul .sub-menu').hide();
    $('body').removeClass('active');
    $('#menu-header-main-menu').removeClass('list-active');
		$('.main-header').removeClass('menu-active');
  }
	static animateMenuBackground(state) {
		if (state) {
			$('.mega-menu-background').addClass('active');
		} else {
			$('.mega-menu-background').removeClass('active');
		}
	}
  bindBackEvents() {
    $('.backBtn').on('click', function(e) {
        e.preventDefault();
        HeaderMenu.hideMegaMenu();
    });
		$('.closeMenu').on('click', function(e){
      e.preventDefault();
			HeaderMenu.closeMenu();
			$('.backBtn').trigger('click');
			HeaderMenu.searchTrigger();
      HeaderMenu.hideMegaMenu();
		});
  }
	static showMegaMenu(item) {
    const subMenuWrapper = item.find('.sub-menu');
    item.addClass('open');
    subMenuWrapper.addClass('active');
    subMenuWrapper.show();
		$('#menu-header-main-menu').addClass('list-active');
		$('.main-header').addClass('menu-active');
  }
  static hideMegaMenu() {
    const activeSubMenu = $('.sub-menu.active');
    const activeSubMenuItems = $('.menu-item-has-children');
    activeSubMenu.hide();
    activeSubMenu.removeClass('active');
    activeSubMenuItems.removeClass('open');
    $('body').removeClass('open');
		$('#menu-header-main-menu').removeClass('list-active');
		$('.main-header').removeClass('menu-active');
    }
	static activeMenu() {
		$('.menu-wrapper').addClass('active');
		$('.menu-wrapper').show();
		$('.menu-label').text("Close");
	}		
	static closeMenu() {
		$('.menu-wrapper').removeClass('active');
		$('.menu-wrapper').hide();
		$('.menu-label').text("Menu");
	}	
	static activeSearchBar() {
		$('.search-wrapper').addClass('active');
		$('.search-wrapper').show();
		$('.btn-search .icon').addClass("icon-close");
		$('.btn-search .icon').removeClass("icon-search");
	}
	static hideSearchBar() {
		$('.search-wrapper').removeClass('active');
		$('.search-wrapper').hide();
		$('.btn-search .icon').addClass("icon-search");
		$('.btn-search .icon').removeClass("icon-close");
	}
	init() {
		this.bindHeaderEvents();
		this.submitSearchForm();
		this.sticky();
	}
	removeEvents() {
		this.search.off();
		this.menuItemsLinks.off();
		$('#submit_form').off();
		$('.backBtn').off();
		$('.closeMenu').off();
	}
}
export default new HeaderMenu();
